module.exports = __webpack_public_path__ + "static/media/22ESCWA12.f8d5a49e.jpg";